import clsx from "clsx"
import { ReactElement } from "react";
import Pagination from "../pages/components/Pagination";

export interface ColumnDatatable {
    label: string;
    key: string;
    headerClassName?: string;
    className?: string;
    getValue?: (row: any) => ReactElement;
}

type Props = {
    columns: ColumnDatatable[];
    data: any[];
    currentPage?: number;
    totalPages?: number;
    onPageChange?: (page: number) => void;
    onClickRow?: (row: any) => void;
    tableClassName?: string;
    isLoading?: boolean;
    placeholderLoading?: number;
    textNoWrap?: boolean;
    cursorPointer?: boolean;
}

export const DatatableComponent = ({ columns, data, currentPage, totalPages, onPageChange, onClickRow, tableClassName, isLoading, placeholderLoading, textNoWrap: textNoWrap, cursorPointer = true }: Props) => {
    
    
    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ overflow: 'auto', height: 'fit-content' }}>
                <table className={clsx('nb-datatable', tableClassName, { 'text-nowrap': textNoWrap })}>
                    <thead>
                        <tr>
                            {columns.map((c, i) => (
                                <th key={i} className={clsx(c.headerClassName)}>
                                    {c.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {!isLoading ? data.map((d, idata) => (
                            <tr key={idata} onClick={() => onClickRow?.(d)} style={{ cursor: cursorPointer ? 'pointer': 'auto' }}>
                                {columns.map((c, icolumn) => (
                                    <td key={`${idata}_${icolumn}`} scope="row" className={clsx(c.className)}>
                                        {c.getValue ? (
                                            <>
                                                {c.getValue(d)}
                                            </>
                                        ): (
                                            <>
                                                {d[c.key]}
                                            </>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        )): (
                            Array.from({ length: placeholderLoading ?? 5 }).map((_, i) => (
                                <tr key={i}>
                                    {columns.map((_, icolumn) => (
                                        <td scope="row" key={`${i}_${icolumn}`}>
                                            <span className='skeleton skeleton--text' style={{width: '70%'}} /> 
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {Boolean(currentPage && totalPages && onPageChange) && (
                <div className="mt-4 d-flex w-100 flex-row">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                    />
                </div>
            )}
        </div>
    )
} 